import _ from 'lodash'
import {
  CHART_COLORS,
  CHART_COLORS_ALPHA_005,
  CHART_COLORS_ALPHA_02,
  CHART_COLORS_ALPHA_05,
  COLORS
} from '@/modules/campaign-manage/helpers/ChartColours'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'

export default {
  computed: {
    chartType() {
      return this.model.trigger === campaignTriggerTypes.TRIGGER_NONE
        ? 'bar'
        : 'line'
    },
    chartsData() {
      let data = _.cloneDeep(this.reportData)
      Object.keys(data).forEach(channel => {
        const height = this.getChannelHeight(data[channel].datasets.length)
        data[channel].datasets.forEach((item, index) => {
          const color = COLORS[index] || COLORS[0]
          data[channel].datasets[index].fill = true
          data[channel].datasets[index].label = this.getTranslatedLabel(
            channel,
            data[channel].datasets[index].label
          )
          data[channel].datasets[index].lineTension = 0
          data[channel].datasets[index].borderColor = CHART_COLORS[color]
          data[channel].datasets[index].backgroundColor = ctx => {
            return this.generateLineGradient(ctx, color, height)
          }

          if (item.label === 'Open Rate' || item.label === 'Click Rate') {
            data[channel].datasets[index].yAxisID = 'y1'
          }
        })
      })

      return data
    },
    chartData() {
      return this.chartsData[this.channel] || {}
    }
  },
  methods: {
    getTranslatedLabel(channel, label) {
      const metric = label.split(`${channel}_`)[1]
      return metric
        ? this.$t(`CampaignChannelAnalytics_Metric_${metric}`)
        : label
    },
    getChannelHeight(metricsNumber) {
      const minHeight = 250
      const calculatedHeight = metricsNumber * 60
      return calculatedHeight > minHeight ? calculatedHeight : minHeight
    },
    generateLineGradient(context, color, height) {
      const canvas = context.chart.ctx
      const gradient = canvas.createLinearGradient(0, 0, 0, height)
      if (this.chartType === 'bar') {
        gradient.addColorStop(0, CHART_COLORS[color])
        gradient.addColorStop(1, CHART_COLORS_ALPHA_05[color])
      } else {
        gradient.addColorStop(0, CHART_COLORS_ALPHA_05[color])
        gradient.addColorStop(0.5, CHART_COLORS_ALPHA_02[color])
        gradient.addColorStop(1, CHART_COLORS_ALPHA_005[color])
      }

      return gradient
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/mixins/AnalyticsMixin.js